export default function Commingsoon (){
    return(
        <h2> Comming Soon</h2>
    )
}